import React, { useEffect, useState } from 'react';

export default function LiveTimestamp({ style = {} }) {
  const [time, setTime] = useState(() => formatBrussels(new Date()));

  useEffect(() => {
    let timeoutId;
    const tick = () => {
      setTime(formatBrussels(new Date()));
      // Re-align to the next whole second to avoid drift.
      timeoutId = setTimeout(tick, 1000 - (Date.now() % 1000));
    };
    timeoutId = setTimeout(tick, 1000 - (Date.now() % 1000));
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <span
      aria-live="off"
      style={{
        fontFamily: 'var(--mono)',
        fontSize: 'clamp(9px, 0.7vw, 11px)',
        letterSpacing: '0.28em',
        color: 'rgba(255,255,255,0.4)',
        textTransform: 'uppercase',
        ...style,
      }}
    >
      ─ {time} BXL ─
    </span>
  );
}

function formatBrussels(date) {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Brussels',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);
}
